
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export interface RouteContext {
  contextType: 'collection' | 'tag' | 'board' | 'inbox' | null;
  contextId: string | null;
}

export const useRouteContext = (): RouteContext => {
  const location = useLocation();
  
  return useMemo(() => {
    const path = location.pathname;
    
    // Match collection routes: /collection/{id}
    const collectionMatch = path.match(/^\/collection\/([^\/]+)$/);
    if (collectionMatch) {
      return {
        contextType: 'collection',
        contextId: collectionMatch[1]
      };
    }
    
    // Match tag routes: /tag/{id}
    const tagMatch = path.match(/^\/tag\/([^\/]+)$/);
    if (tagMatch) {
      return {
        contextType: 'tag',
        contextId: tagMatch[1]
      };
    }
    
    // Match board routes: /board/{id}
    const boardMatch = path.match(/^\/board\/([^\/]+)$/);
    if (boardMatch) {
      return {
        contextType: 'board',
        contextId: boardMatch[1]
      };
    }
    
    // Match inbox route: /inbox
    if (path === '/inbox') {
      return {
        contextType: 'inbox',
        contextId: 'inbox'
      };
    }
    
    // No valid context found
    return {
      contextType: null,
      contextId: null
    };
  }, [location.pathname]);
};
